import React from "react";
import Header from "../common/header";
import Footer from "../common/footer";
import CourseslevellistPage from "../layout/courselevel/courselevel";

function CoursesLevelList() {
    return (
        <div>
            <Header />
            <CourseslevellistPage/>
            <Footer />
        </div>
    );
}

export default CoursesLevelList;